<div class="report-overview">
  <div class="report-overview__illustration">
    <img
      src="../../../assets/images/report-illustration.svg"
      alt="Report illustration"
    />
  </div>
  <div class="report-overview__content">
    <p class="report-overview__title">{{ title }}</p>
    <ul class="report-overview__bullets">
      <li *ngFor="let bullet of bullets">{{ bullet }}</li>
    </ul>
  </div>
</div>
